import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment } from '@angular/router';
import { AppFeaturesService } from '@core/services/app-features.service';

export const b2bEnabledGuard: CanMatchFn = (_route, segments) => {
  return !isAsmRoute(segments) && inject(AppFeaturesService).isB2BEnabled();
};

export const asmEnabledGuard: CanMatchFn = (_route, segments) => {
  const features = inject(AppFeaturesService);
  return features.isASMEnabled() && (isAsmRoute(segments) || !features.isB2BEnabled());
};

function isAsmRoute(segments: UrlSegment[]): boolean {
  const path = `/${segments.map(segment => segment.path).join('/')}`;
  return path === '/asm' || path.startsWith('/asm/') || path === '/customer/emulate' || path === '/agent/login';
}
